var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 0.0833435H2.16634C1.12467 0.0833435 0.0830078 1.02084 0.0830078 2.16668V5.30209C0.0830078 6.05209 0.530925 6.69793 1.12467 7.06251V18.8333C1.12467 19.9792 2.27051 20.9167 3.20801 20.9167H17.7913C18.7288 20.9167 19.8747 19.9792 19.8747 18.8333V7.06251C20.4684 6.69793 20.9163 6.05209 20.9163 5.30209V2.16668C20.9163 1.02084 19.8747 0.0833435 18.833 0.0833435ZM13.6247 12.5833H7.37467V10.5H13.6247V12.5833ZM18.833 5.29168H2.16634V2.16668H18.833V5.29168Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add_item.b4f7a0c3442949e2f6a07f12c63ee441.svg";
export { ForwardRef as ReactComponent };